var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content text-center"},[_c('div',{staticClass:"container-fluid mt-5 mb-5"},[_c('ModalPreviewVideo',{attrs:{"current-documento":_vm.videoObject}})],1)])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }